import { useEffect, useState, useCallback } from 'react';

const subscribers = new Set<(openId: string | null) => void>();
let currentOpenId: string | null = null;

const notify = () => {
  subscribers.forEach((cb) => cb(currentOpenId));
};

export function useExclusiveOpen(id: string): readonly [boolean, (open: boolean) => void] {
  const [isOpen, setIsOpen] = useState(currentOpenId === id);

  useEffect(() => {
    const cb = (openId: string | null) => {
      setIsOpen(openId === id);
    };
    subscribers.add(cb);
    return () => {
      subscribers.delete(cb);
    };
  }, [id]);

  const setOpen = useCallback(
    (open: boolean) => {
      currentOpenId = open ? id : null;
      notify();
    },
    [id],
  );

  return [isOpen, setOpen] as const;
}